var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMerchantsandclients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 9.54675C23.9199 9.53342 23.8266 9.53342 23.7466 9.54675C21.9066 9.48009 20.4399 7.97342 20.4399 6.10675C20.4399 4.20008 21.9733 2.66675 23.8799 2.66675C25.7866 2.66675 27.3199 4.21342 27.3199 6.10675C27.3066 7.97342 25.8399 9.48009 23.9999 9.54675Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6266 19.2534C24.4532 19.5601 26.4666 19.2401 27.8799 18.2934C29.7599 17.0401 29.7599 14.9867 27.8799 13.7334C26.4532 12.7867 24.4132 12.4667 22.5865 12.7867",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96002 9.54675C8.04002 9.53342 8.13335 9.53342 8.21335 9.54675C10.0533 9.48009 11.52 7.97342 11.52 6.10675C11.52 4.20008 9.98668 2.66675 8.08002 2.66675C6.17335 2.66675 4.64001 4.21342 4.64001 6.10675C4.65335 7.97342 6.12002 9.48009 7.96002 9.54675Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33338 19.2534C7.50671 19.5601 5.49338 19.2401 4.08004 18.2934C2.20004 17.0401 2.20004 14.9867 4.08004 13.7334C5.50671 12.7867 7.54671 12.4667 9.37337 12.7867",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 19.5067C15.9199 19.4934 15.8266 19.4934 15.7466 19.5067C13.9066 19.44 12.4399 17.9334 12.4399 16.0667C12.4399 14.16 13.9733 12.6267 15.8799 12.6267C17.7866 12.6267 19.3199 14.1734 19.3199 16.0667C19.3066 17.9334 17.8399 19.4534 15.9999 19.5067Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.12 23.7067C10.24 24.9601 10.24 27.0134 12.12 28.2667C14.2533 29.6934 17.7466 29.6934 19.88 28.2667C21.76 27.0134 21.76 24.9601 19.88 23.7067C17.76 22.2934 14.2533 22.2934 12.12 23.7067Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchantsandclients);
export default __webpack_public_path__ + "static/media/merchantsandclients.fb62ceb10afe2dda6a4de3fc4d0156d0.svg";
export { ForwardRef as ReactComponent };